import { render, staticRenderFns } from "./Responsibles.vue?vue&type=template&id=11cb8c2c&scoped=true&"
import script from "./Responsibles.vue?vue&type=script&lang=js&"
export * from "./Responsibles.vue?vue&type=script&lang=js&"
import style0 from "./Responsibles.vue?vue&type=style&index=0&id=11cb8c2c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11cb8c2c",
  null
  
)

export default component.exports